import DotsLoading from 'components/loadings/dotsLoading';
import SearchInput from 'components/searchInput';
import {useWholesaler} from 'context/wholesaler';
import useGetSubProducts from 'pages/farm/subProduct/hooks/useGetSubProducts';
import React, {useState} from 'react';
import {useMatch, useNavigate, useParams} from 'react-router-dom';
import useDebounce from 'utilities/hooks/debounce/useDebounce';

const PurchaseSubproducts = () => {
  const {productId} = useParams();
  const navigate = useNavigate();
  const isFarmRoute = useMatch('/farm/add-ad/purchase/subproducts/:productId');

  const {subProducts, isLoading} = useGetSubProducts(
    productId ? productId : '',
  );

  const [Search, setSearch] = useState('');
  const searchValue = useDebounce(Search, 500);
  const {wholesaler, updateSubProduct} = useWholesaler();

  return (
    <>
      <h2 className="w-full flex text-[18px] font-normal">انتخاب محصول </h2>
      <div className="flex flex-col items-center  w-full h-[95%] justify-center gap-4">
        <div className="h-[10%] flex w-full justify-center">
          <SearchInput Search={Search} setSearch={setSearch} />
        </div>
        {isLoading ? (
          <div className="w-full flex items-center justify-center">
            <DotsLoading />
          </div>
        ) : (
          <>
            {subProducts
              ?.filter(item => item.title.includes(searchValue))
              .map((item, index) => (
                <button
                  key={index}
                  className="w-full flex text-gray-6 font-medium text-[15px] leading-[20px]"
                  onClick={() => {
                    if (wholesaler?.appType === 'post') {
                      navigate('/wholesaler/add-ad/info');
                      updateSubProduct(item.guid);
                    } else {
                      navigate(
                        `${isFarmRoute ? '/farm' : '/wholesaler'}` +
                          '/add-ad/purchase/info/' +
                          item.guid,
                        {
                          state: {
                            title: item.title,
                          },
                        },
                      );
                    }
                  }}
                >
                  {item.title}
                </button>
              ))}
          </>
        )}
      </div>
    </>
  );
};

export default PurchaseSubproducts;
